const navsBridge = [
    { name: "labels.bridges", url: "/data-view/containers/", icon: "trash-can", role: "tech" },
]

export default navsBridge